import { useState } from "react";
import logomain from "../../../images/logo-main.png";
import { OTP } from "../OTP/OTP";
import "../../../css/pages/login.css";
import { ForgotPaswordFunction } from "./ForgotPaswordFunction";
import { LoadPanel, Toast } from "devextreme-react";
import { useDispatch } from "react-redux";
export const ForgotPasword = () => {
  const [otpshow, setotpshow] = useState(false);
  const clas = new ForgotPaswordFunction();
  const [email, setemail] = useState("");
  const [validation, setvalidation] = useState("");
  const [loading, setLoading] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  const dispatch = useDispatch();

  const OnSubmit = () => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    if (!emailPattern.test(email.trim())) {
      setvalidation(clas.ErrorValidationConstant);
      return;
    }
    clas.ForgotPassword(
      setotpshow,
      {
        email: email.trim(),
        deviceType: 3,
        deviceToken: "abcd",
        deviceId: "abcd",
      },
      setToastConfig,
      toastConfig,
      setvalidation,
      dispatch,
      setLoading
    );
  };

  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        position={"top"}
        width={"auto"}
      />
      {!otpshow ? (
        <section className="login">
          <div className="container">
            <div className="login__flex">
              <div className="login__item login__item--img" />
              <div className="login__item login__item--form">
                <div className="branding">
                  <div className="branding__logo">
                    <img
                      src={logomain}
                      alt="Logo | Welcome To UPA"
                      className="branding__logo__img"
                    />
                  </div>
                  <div className="branding__info">
                    <h1 className="title title--h1">Forgot Your Password?</h1>
                    <p className="text">Manage your password here!</p>
                  </div>
                </div>

                <div className="login__form">
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      OnSubmit();
                    }}
                  >
                    <div className="form__group">
                      <label htmlFor="email" className="form__label">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="form-control"
                        style={{ border: validation ? "2px solid red" : "" }}
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => {
                          setemail(e.target.value);
                          setvalidation("");
                        }}
                      />
                    </div>
                    {validation && (
                      <p className="field-error" style={{ marginTop: "-13px" }}>
                        {validation}
                      </p>
                    )}
                    <div className="form__group">
                      <button
                        className="btn btn--primary btn--full"
                        onClick={() => {
                          OnSubmit();
                        }}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : (
        <OTP setotpshow={setotpshow} />
      )}
    </>
  );
};
